import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export type KeyValueRow = readonly [label: ReactNode, value: ReactNode] | null | false;

const COLS = { 1: 'sm:grid-cols-1', 2: 'sm:grid-cols-2', 3: 'sm:grid-cols-2 lg:grid-cols-3' } as const;

export function KeyValue({ rows, columns = 1 }: { rows: KeyValueRow[]; columns?: 1 | 2 | 3 }) {
  return (
    <dl className={cn('grid grid-cols-1 gap-x-8 gap-y-3', COLS[columns])}>
      {rows.filter((r): r is readonly [ReactNode, ReactNode] => Boolean(r)).map(([label, value], i) => (
        <div key={i} className="min-w-0 space-y-0.5">
          <dt className="text-xs font-medium text-muted-foreground">{label}</dt>
          <dd className="text-sm break-words">{value ?? '—'}</dd>
        </div>
      ))}
    </dl>
  );
}
